import { useEffect, useState } from "react";

const svgCache = new Map<string, string>();

interface FigmaSvgLayerProps {
  className: string;
  src: string;
}

export function FigmaSvgLayer({ className, src }: FigmaSvgLayerProps) {
  const [svg, setSvg] = useState(() => svgCache.get(src) ?? "");

  useEffect(() => {
    let active = true;
    const cached = svgCache.get(src);

    if (cached) {
      setSvg(cached);
      return () => {
        active = false;
      };
    }

    setSvg("");

    fetch(src)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to load ${src}`);
        }
        return response.text();
      })
      .then((text) => {
        if (!text.trimStart().startsWith("<svg")) {
          throw new Error(`Asset is not SVG: ${src}`);
        }
        svgCache.set(src, text);
        if (active) {
          setSvg(text);
        }
      })
      .catch(() => {
        if (active) {
          setSvg("");
        }
      });

    return () => {
      active = false;
    };
  }, [src]);

  if (!svg) {
    return <img className={className} src={src} alt="" draggable={false} aria-hidden="true" data-figma-src={src} />;
  }

  return <span className={className} aria-hidden="true" data-figma-src={src} dangerouslySetInnerHTML={{ __html: svg }} />;
}
